module.exports = __webpack_public_path__ + "img/confirm.e7f3fb80.svg";